import { MutationTree } from 'vuex';
import { TrainerPayrollState } from './types';
import trainerPayroll, { Value } from '@/shared/model/trainerPayroll';

export const mutations: MutationTree<TrainerPayrollState> = {
  setTrainerPayrolls(state, payload: Value) {
    state.trainerPayrolls.items = payload.value.map(trainerPayroll.parse);
    state.trainerPayrolls.total = payload['@odata.count'] || 0;
    state.trainerPayrolls.isLoading = false;
  },
  setTrainerPayrollsTotal(state, payload: number) {
    state.trainerPayrolls.total = payload;
  },
  setTrainerPayrollsIsLoading(state, payload: boolean) {
    state.trainerPayrolls.isLoading = payload;
  },
  resetTrainerPayrollsPaging(state) {
    state.trainerPayrolls.searchParams.dataOption.page = 1;
    state.trainerPayrolls.searchParams.dataOption.itemsPerPage = 10;
    state.trainerPayrolls.searchParams.dataOption.filter = '';
    state.trainerPayrolls.searchParams.filter = '';
  },
};
